import { render } from "./HeaderCN.vue?vue&type=template&id=0ec97202&scoped=true"
import script from "./HeaderCN.vue?vue&type=script&lang=js"
export * from "./HeaderCN.vue?vue&type=script&lang=js"

import "./HeaderCN.vue?vue&type=style&index=0&id=0ec97202&lang=less&scoped=true"
import "./HeaderCN.vue?vue&type=style&index=1&id=0ec97202&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec97202"]])

export default __exports__